<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    data(){
        return {
            timer: null
        };
    },
    created(){
        this.verify();
    },
    methods: {
        verify(){
            this.timer = setTimeout(() => {
                if(this.payload && this.payload.exp * 1000 <= Date.now()){
                    this.$store.dispatch('logout');
                }
            }, 1000);
        }
    },
    computed: {
        payload(){
            return this.$store.state.payload;
        }
    }
}
</script>